export type DomEvent<T extends Element = Element, E extends Event = Event> = E & {
  // currentTarget: EventTarget & T;
  currentTarget: T;
};

export function focusAdjacent(target: HTMLInputElement, dir: 'next' | 'prev') {
  let el: Element | null = target;
  while (true) {
    el = dir === 'next' ? el.nextElementSibling : el.previousElementSibling;
    if (!el) {
      break;
    }
    if (el.tagName.toLowerCase() === 'input') {
      (el as HTMLInputElement).focus();
      break;
    }
  }
}

export function escapeHtml(unsafe: string) {
  // https://stackoverflow.com/questions/6234773/can-i-escape-html-special-chars-in-javascript
  return unsafe.replace(/[&<>"']/g, function (m) {
    switch (m) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      default:
        return '&#039;';
    }
  });
  // return unsafe
  //   .replaceAll('&', '&amp;')
  //   .replaceAll('<', '&lt;')
  //   .replaceAll('>', '&gt;')
  //   .replaceAll('"', '&quot;')
  //   .replaceAll("'", '&#039;');
}

export class SafeHtml {
  // A legal and safely-built DOM string that can be directly embedded.
  #html: string;

  constructor(value: string | SafeHtml) {
    if (value instanceof SafeHtml) {
      this.#html = value.#html;
    } else {
      this.#html = escapeHtml(value);
    }
  }

  get html() {
    return this.#html;
  }

  get text() {
    return escapeHtml(this.#html);
  }
}
